export default "__VITE_ASSET__Ch_7l3dX__"